<template>
  <span class="app-download-code" role="status">
    <img v-if="image" :src="image" alt="官方下载二维码" />
    <span v-else>{{ !downloadUrl ? '下载暂未开放' : error ? '二维码生成失败，可使用下载链接' : '正在生成二维码…' }}</span>
  </span>
</template>
<script setup>
import { computed, onBeforeUnmount, ref, watch } from 'vue'
import QRCode from 'qrcode'
import { safeExternalUrl } from '../config/navigation.js'

const props = defineProps({ url: { type: String, default: '' } })
const downloadUrl = computed(() => safeExternalUrl(props.url))
const image = ref(''), error = ref(false)
let version = 0
watch(downloadUrl, async url => {
  const ticket = ++version
  image.value = ''
  error.value = false
  if (!url) return
  try {
    const data = await QRCode.toDataURL(url, { width: 220, margin: 4, errorCorrectionLevel: 'M' })
    if (ticket === version) image.value = data
  } catch {
    if (ticket === version) error.value = true
  }
}, { immediate: true })
onBeforeUnmount(() => { version++ })
</script>
<style scoped>
.app-download-code { display: inline-grid; place-items: center; width: 110px; height: 110px; background: #fff; border: 1px solid #dce8f3; border-radius: 8px; overflow: hidden; vertical-align: middle; }
.app-download-code img { display: block; width: 100%; height: 100%; object-fit: contain; }
.app-download-code > span { padding: 8px; color: #74849a; font-size: 12px; line-height: 1.5; text-align: center; }
</style>
